import AppFooter from './components/AppFooter.vue'
import AppHeader from './components/AppHeader.vue'

import CtaButton from './components/atoms/CtaButton.vue'
import MailCta from './components/atoms/MailCta.vue'
import TextField from './components/atoms/TextField.vue'

export default {
  AppFooter,
  AppHeader,
  
  CtaButton,
  MailCta,
  TextField
}